import { createI18n } from 'vue-i18n'
import enUS from './enUS'
import zhCN from './zhCN'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'enUS',
  fallbackLocale: 'enUS',
  messages: {
    enUS,
    zhCN,
  },
})

export default i18n

export const setLocale = (locale: string) => {
  ;(i18n.global.locale as unknown as { value: string }).value = locale
  localStorage.setItem('locale', locale)
}

export const getLocale = () => (i18n.global.locale as unknown as { value: string }).value
